export const setErrorBoundaryImage = data => ({ type: 'SET_IMAGE', payload: data });
export default setErrorBoundaryImage;
